import React from "react";
import axios from "axios";

import {
    url_user,
    url_user_email,
    url_user_lang,
    url_user_self,
    url_user_status,
    url_users,
    url_users_role
} from "../url";


export default function DB_User(token) {

    const formData = new FormData()
    formData.append('token', token)

    const appendToken = (data) => {
        const fd = new FormData()
        for (const pair of data.entries()) {
            fd.append(pair[0], pair[1]);
        }
        fd.append('token', token);
        return fd
    }


    const getRoles = async () => {
        return await axios.get(url_users_role)
    }

    const getUsers = async () => {
        return await axios.post(url_users, formData)
    }

    const getUser = async (user_id) => {
        return await axios.post(url_user + user_id, formData)
    }

    const createUser = (user) => {
        return axios.post(url_user, appendToken(user))
    }

    const updateUser = (user) => {
        return axios.put(url_user, appendToken(user))
    }

    const updateUserSelf = (user) => {
        return axios.put(url_user_self, appendToken(user))
    }

    const checkEmail = (data) => {
        return new Promise(resolve => {
            axios.post(url_user_email, data)
                .then(res => {
                    if (res.status === 200) {
                        resolve(true)
                    } else {
                        resolve(false)
                    }
                })
        })
    }

    const statusUser = (data) => {
        return axios.post(url_user_status, appendToken(data))
    }

    const changeLang = (user, lang) => {
        return axios.post(url_user_lang + user + '/' +  lang)
    }

    return {
        getRoles,
        getUsers,
        getUser,
        createUser,
        updateUser,
        updateUserSelf,
        checkEmail,
        statusUser,
        changeLang,
    }
}
